import { Box, Chip, LinearProgress, Stack, Typography } from "@mui/material";
import { Report } from "../types/Report";

interface Props {
  report: Report;
}

export default function ReportStatusIndicator({ report }: Props) {
  // TODO: Indicador circular cuando está en progreso, con colores y que diga porcentaje ya que tenemos el procesado y total. También puede que haya procesados pero con errores, ver cómo mostrar.
  // También podría mostrar un último ping, como una fecha hora para saber última actualización.
  return (
    <Stack py={2}>
      {report.accountsProcessed && report.accountsTotal && (
        <>
          {report.accountsProcessed < report.accountsTotal && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: "100%", mr: 1 }}>
                <LinearProgress
                  variant="determinate"
                  value={
                    (report.accountsProcessed / report.accountsTotal) * 100 || 0
                  }
                />
              </Box>
              <Box sx={{ minWidth: 35 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                >{`${Math.round(
                  (report.accountsProcessed / report.accountsTotal) * 100 || 0,
                )}%`}</Typography>
              </Box>
            </Box>
          )}
          <Typography variant="body2" color="text.secondary">
            Procesados: {report.accountsProcessed} / {report.accountsTotal}
          </Typography>
          {report.accountReports && (
            <>
              <Typography variant="body2" color="text.secondary">
                Correctos:{" "}
                {report.accountReports?.filter((ar) => !ar.error).length || 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Errores:{" "}
                {report.accountReports?.filter((ar) => ar.error).length || 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Última actualización:{" "}
                {new Date(report.updatedAt).toLocaleString()}
              </Typography>
            </>
          )}
        </>
      )}
      <Chip
        label={report.status}
        color={
          report.status === "Listo"
            ? "success"
            : report.status === "En progreso"
              ? "primary"
              : "error"
        }
        sx={{ width: 100, mt: 2 }}
      />
    </Stack>
  );
}
